export interface GrantData {
  id: string
  externalId: string
  giftId?: string
  projectTitle: string
  projectType: string
  charterArea: string
  programTheme?: string
  requestStatus?: string
  summary: string
  fundingArea: string
  fundingSource?: string
  organizationName: string
  organizationType: string
  organizationTaxId: string
  organizationExternalId: string
  startDate?: Date
  approvedDate?: Date
  endDate?: Date
  closedDate?: Date
  agreementAmount?: number
  totalAmount?: number
  parentGrantExternalId?: string
  primaryContactName?: string
  primaryContactEmail?: string
}

export interface UpdateGrantData {
  projectTitle: string
  programTheme: string
  requestStatus: string
  summary: string
  organizationName: string
  organizationType: string
  startDate?: Date
  endDate?: Date
  agreementAmount?: number
  totalAmount?: number
}

export interface CreateResearcherData {
  firstName: string
  lastName: string
  email: string
  role: string
}

export interface CreateGrantRequest {
  externalId: string
  projectTitle: string
  programTheme: string
  requestStatus: string
  summary: string
  organizationName: string
  organizationType: string
  startDate: Date
  endDate: Date
  agreementAmount: number
  totalAmount: number
  researchers: CreateResearcherData[]
}

export interface GrantUserData {
  id: string
  grantId: string
  organizationId: string
  firstName: string
  lastName: string
  role: string
  email: string
  externalContactNumber?: string
  externalGrantId?: string
}

export interface GrantWorkData {
  doi: string
  title: string
  workAbstract: string
  publisher: string
  workType: string
  source: string
  link: string
}

export interface GrantListPage {
  totalElements: number
  totalPages: number
  currentPage: number
  content: GrantData[]
  first: boolean
  last: boolean
}

export enum GrantProgram {
  All = 'all',
  HumilityInTheology = 'Humility-in-Theology',
  CharacterVirtueDevelopment = 'Character Virtue Development',
  HumanSciences = 'Human Sciences',
  VirtuesAndWellBeing = 'Virtues and Well-Being',
}

export enum GranteeType {
  All = 'all',
  NonProfitOrganization = 'Non-profit Organization',
  EducationalInstitution = 'Educational Institution',
  GovernementAgency = 'Government Agency',
  Individual = 'Individual',
}

export interface GrantFilterValue {
  programTheme: string
  grantYear: string
  organizationType: string
}

export interface SearchGrantsParams {
  page: number
  size: number
  sort: string[]
  filters: Record<keyof GrantFilterValue, string>
  title?: string
}

export const defaultGrantsPage: GrantListPage = {
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  content: [],
  first: false,
  last: false,
}
